import React from 'react';

// Named size presets instead of ad-hoc per-instance width/height/text classes.
// Previously every screen hand-rolled its own pixel combo via `className`,
// which silently collided with this component's own default text-size
// classes at matching breakpoints (Tailwind resolves same-specificity
// conflicts by generation order, not by where a class appears in the JSX --
// unpredictable in practice). Centralizing sizing here removes that entire
// class of bug and keeps every CTA on the site visually consistent.
// Font sizes use clamp() so they scale continuously with viewport width --
// no breakpoint cliff where text suddenly jumps and wraps/overflows.
export const SIZE_CLASSES = {
  hero: 'w-full max-w-[300px] sm:max-w-[430px] px-8 py-4 sm:py-5 rounded-[45px] text-[clamp(1.05rem,4vw,2.1rem)] border-[4px]',
  cta: 'w-full max-w-[300px] sm:max-w-[420px] px-6 py-3 sm:py-4 rounded-[40px] text-[clamp(0.95rem,2.8vw,1.4rem)] border-[4px]',
  compact: 'w-full max-w-[300px] sm:max-w-[420px] px-6 py-2.5 rounded-[36px] text-[clamp(0.8rem,2.2vw,1.1rem)] border-[3px]',
  pill: 'w-[58px] h-[58px] sm:w-[68px] sm:h-[68px] rounded-full text-xl sm:text-2xl border-[3px] shrink-0',
  counter: 'w-[64px] h-[64px] sm:w-[76px] sm:h-[76px] rounded-full text-xl sm:text-2xl border-[3px] shrink-0',
};

// Shared with anchor-based CTAs (see Finish.jsx). Some actions must be real
// links rather than buttons -- mobile Safari and in-app browsers block
// programmatic window.open even from a click handler -- but they still have to
// look identical to every other CTA on the site. Exporting the base keeps the
// two in lockstep instead of duplicating a 200-character class string.
export const BUTTON_BASE =
  'flex items-center justify-center leading-tight uppercase border-white transition-transform duration-150 ease-out hover:scale-[1.03] active:scale-[0.97]';

const Button = ({ onClick, children, className = '', disabled, size = 'cta' }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`bg-[#FD62A6] text-white drop-shadow ${BUTTON_BASE} disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100 ${SIZE_CLASSES[size] || SIZE_CLASSES.cta} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
